exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sk-chase {\n  margin: 24px 0 32px 0;\n  margin-left: 45%;\n  width: 40px;\n  height: 40px; }\n\n.sk-chase-dot:before {\n  background-color: rgba(0, 0, 0, 0.87) !important; }\n", ""]);

// exports
